import { useRouter } from 'next/router';
import { useCallback, useMemo } from 'react';

import type { PeriodIndex } from '../components/PeriodMenu';
import type { SortType } from '../types/layout';
import { replaceQueryParam2 } from '../utils/routing';

// type overloads to return right value type
function useQueryNavigation(queryName: 'period'): {
  value: PeriodIndex;
  update: (newValue: string) => void;
};
function useQueryNavigation(queryName: 'sort'): {
  value: SortType;
  update: (newValue: string) => void;
};
function useQueryNavigation(queryName: string): {
  value: string;
  update: (newValue: string) => void;
};

function useQueryNavigation(queryName: string) {
  const { pathname, query, asPath, push } = useRouter();
  // @ts-ignore
  const value = query[queryName] as string;

  const update = useCallback(
    newValue => {
      const { href, as } = replaceQueryParam2(pathname, query, asPath, queryName, newValue);
      push(href, as, { shallow: true, scroll: false });
    },
    [pathname, query, asPath, queryName, push],
  );

  return useMemo(
    () => ({
      value,
      update,
    }),
    [value, update],
  );
}

export { useQueryNavigation };
